import { render, staticRenderFns } from "./recommend_books.vue?vue&type=template&id=fd0e1818&scoped=true&"
import script from "./recommend_books.vue?vue&type=script&lang=js&"
export * from "./recommend_books.vue?vue&type=script&lang=js&"
import style0 from "./recommend_books.vue?vue&type=style&index=0&id=fd0e1818&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0e1818",
  null
  
)

export default component.exports